export default __webpack_public_path__ + "static/media/readyImage.0f3a8a27.png";